import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatusGraphNode } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatusGraphService {
  constructor(private _http: HttpClient) {}

  fetch(): Observable<StatusGraphNode[]> {
    return this._http.get<StatusGraphNode[]>(`/statuses`);
  }

  save(statusGraph: StatusGraphNode[]): Observable<void> {
    return this._http.put<void>(`/statuses`, statusGraph);
  }
}
